import { useParams } from "react-router-dom";
import { SearchX } from "lucide-react";

import { ApiKeyForm } from "@/components/api-key/api-key-form";
import { EmptyState } from "@/components/empty-state";
import { DetailSkeleton } from "@/components/loading-skeletons";
import { PageHeader } from "@/components/layout/page-header";
import { useApiKeysQuery } from "@/hooks/use-api-keys";

const BREADCRUMBS = [{ label: "API Keys", to: "/settings/api-keys" }];

export function EditApiKeyPage() {
  const { id } = useParams<{ id: string }>();
  const { data: apiKeys, isLoading, error } = useApiKeysQuery();

  const apiKey = apiKeys?.find((k) => k.id === id);

  if (isLoading) {
    return (
      <div className="flex flex-1 flex-col gap-6">
        <PageHeader breadcrumbs={BREADCRUMBS} title="Edit API Key" />
        <DetailSkeleton withTitle={false} />
      </div>
    );
  }

  if (error || !apiKey) {
    return (
      <div className="flex flex-1 flex-col gap-6">
        <PageHeader breadcrumbs={BREADCRUMBS} title="Edit API Key" />
        <EmptyState
          icon={SearchX}
          title="API Key Not Found"
          description="The API key you are looking for does not exist."
        />
      </div>
    );
  }

  return <ApiKeyForm mode="edit" apiKey={apiKey} />;
}
